<template>
  <main class="u-margin-top-8x">
    <BaseStateIndicator v-if="hasError" state="error" />
    <BaseSpinner v-else />
  </main>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { BaseSpinner, BaseStateIndicator } from '@te/cdev-design-system';

import { samlSetup } from '@/common/helpers/single-sign-on';
import { getSamlAuthXml } from '@/common/services/SingleSignOn';

export default defineComponent({
  components: {
    BaseSpinner,
    BaseStateIndicator
  },
  metaInfo() {
    return {
      title: this.$t('common.redirecting')
    };
  },
  data() {
    return {
      hasError: false
    };
  },
  async created() {
    try {
      await samlSetup(getSamlAuthXml, 'login_redirect_url');
    } catch {
      this.hasError = true;
    }
  }
});
</script>
